import { useRouting } from 'core/routing/useRouting';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const useNavigateToNoiseClassificationListing = () => {
  const {
    generatePath,
    routes: {
      configuration: {
        noise: { classifications },
      },
    },
  } = useRouting();
  const navigate = useNavigate();
  return useCallback(() => {
    navigate(generatePath(classifications.root));
  }, [classifications.root, generatePath, navigate]);
};
